import React from "react";
import {
  TextField,
  BooleanField,
  NumberField,
  TabbedShowLayout,
  ArrayField,
  Datagrid,
} from "react-admin";
import {
  TitledShow,
  LabeledColumn,
} from "../../_myBase/components/titledRecord";
import { Stack } from "@mui/material";

export default function DiscountPlanShow() {
  return (
    <TitledShow>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Summary">
          <Stack spacing={4} direction="row">
            <LabeledColumn>
              <NumberField source="id" />
              <TextField source="name" />
              <BooleanField source="isDefault" label="Default Plan" />
            </LabeledColumn>
          </Stack>
          <ArrayField source="brackets" label="Pricing Brackets">
            <Datagrid bulkActionButtons={false}>
              <NumberField source="minDays" label="Min Days" />
              <TextField source="type" label="Type" />
              <NumberField
                source="percentage"
                label="%"
                options={{ maximumFractionDigits: 2 }}
              />
            </Datagrid>
          </ArrayField>
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </TitledShow>
  );
}
